import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule ,PreloadAllModules} from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocalStorage } from './extras/localstorage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpHandler } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectizeModule } from 'ng-selectize';
import { NzModalModule } from 'ng-zorro-antd/modal';
//Layout Modules
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';
import { Page403Component } from './extras/403/403.component';
import { Page500Component } from './extras/500/500.component';
//Directives
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Sidebar_Directives } from './shared/directives/side-nav.directive';
import { ChartModule } from 'angular-highcharts';
import {cardPortletRefresh,cardPortletDelete} from './shared/directives/cards.directive';
// Routing Module
import { AppRoutes } from './app.routing';

// App Component
import { AppComponent } from './app.component';


export function HttpLoaderFactory(httpClient: HttpClient) {
　　　　return new TranslateHttpLoader(httpClient);
　　}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, { useHash: true ,
            enableTracing:true,
            preloadingStrategy:PreloadAllModules,
            scrollPositionRestoration: 'enabled'
        }),
        FormsModule,
        ChartModule,
        HttpClientModule,
        BsDatepickerModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
            }
        }),
        NgSelectizeModule,
        NgbModule.forRoot(),
        NzModalModule,
        ReactiveFormsModule
    ],
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        AuthenticationLayoutComponent,
        Sidebar_Directives,
        Page403Component,
        Page500Component,
        cardPortletRefresh,
        cardPortletDelete
       
        
    ],
    providers: [LocalStorage,CookieService],
    bootstrap: [AppComponent]
})


export class AppModule { }
